module.exports = __webpack_public_path__ + "img/CAT_SANOFIAVENTIS.c1bec932.jpg";